// Libraries
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

// Components
import StyledDialog from "../../../../../components/StyledDialog/StyledDialog";
import Message from "../../../../../store/modules/messages/model";
import StyledInput from "../../../../../components/StyledInput/StyledInput";
import StyledButton from "../../../../../components/StyledButton/StyledButton";

// Structure components
import { Container, Label } from "../../../../../structureComponents";

// Store actions
import { setSnackbarState } from "../../../../../store/modules/global/actions";
import { updateMessages } from "../../../../../store/modules/messages/actions";

function UpdateMessage({
  currentVenture,
  selectedMessage,
  active,
  onClose = () => ({}),
  dispatchSnackbar,
  dispatchUpdateMessages,
}) {
  // State
  const [message, setMessage] = useState(new Message({}));
  const [loading, setLoading] = useState(false);

  // Watchers
  useEffect(() => {
    if (selectedMessage) {
      setMessage(new Message({ ...selectedMessage }));
    }
  }, [selectedMessage]);

  useEffect(() => {
    if (selectedMessage && active) {
      setMessage(
        new Message({
          ...selectedMessage,
        })
      );
    } else if (active && !selectedMessage) {
      setMessage(new Message({}));
    }
  }, [active]);

  // Methods
  const handleNameOnChange = (e) => {
    setMessage({ ...message, name: e.target.value });
  };

  const handleTextOnChange = (e) => {
    setMessage({ ...message, text: e.target.value });
  };

  const handleUpdateMessage = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);

      const messageId = selectedMessage.id;
      const ventureId = currentVenture.id;

      await dispatchUpdateMessages(
        { ventureId, messageId },
        {
          name: message.name,
          text: message.text,
        }
      );

      onClose();

      dispatchSnackbar({
        type: "success",
        active: true,
        message: "Pergunta frequente atualizada com sucesso",
      });
    } catch (error) {
      dispatchSnackbar({
        type: "error",
        active: true,
        message: "Infelizmente ocorreu um erro",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <StyledDialog
      title="Atualizar mensagem"
      active={active}
      onClose={() => onClose()}
      maxWidth="sm"
    >
      <form onSubmit={handleUpdateMessage}>
        <Container>
          <Label bold>Nome</Label>
          <Container mt="10px">
            <StyledInput
              value={message.name}
              placeholder="Digite o nome"
              onChange={handleNameOnChange}
            />
          </Container>
        </Container>
        <Container mt="20px">
          <Label bold>Texto</Label>
          <Container mt="10px">
            <StyledInput
              value={message.text}
              placeholder="Digite o texto"
              multiline
              rows={8}
              onChange={handleTextOnChange}
            />
          </Container>
        </Container>
        <Container flex alignCenter justifyEnd mt="40px">
          <Container>
            <StyledButton kind="primary-outlined" onClick={() => onClose()}>
              Cancelar
            </StyledButton>
          </Container>
          <Container ml="20px">
            <StyledButton kind="primary" type="submit" loading={loading}>
              Salvar
            </StyledButton>
          </Container>
        </Container>
      </form>
    </StyledDialog>
  );
}

const mapStateToProps = (state) => ({
  currentVenture: state.ventures.currentVenture,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchUpdateMessages({ ventureId, messageId }, { name, text }) {
    await dispatch(
      updateMessages(
        {
          ventureId,
          messageId,
        },
        {
          name,
          text,
        }
      )
    );
  },

  dispatchSnackbar({ message, type, active }) {
    dispatch(setSnackbarState({ message, type, active }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateMessage);
